import { MagentoClient } from 'lib/core/services/magento'
import { MagentoStoreConfig, ProductData } from 'lib/types'
import { normalizeProduct } from './normalize'
import { ProductAttributeList } from 'lib/core/data/common/productAttributeList/types'

interface FetchProductsParams {
  magentoClient?: MagentoClient
  skus?: string[]
  productAttrList: ProductAttributeList
  storeConfig: MagentoStoreConfig | undefined
}

export const fetchProducts = async ({
  magentoClient,
  skus,
  productAttrList,
  storeConfig
}: FetchProductsParams): Promise<ProductData[] | undefined> => {
  if (!skus || !skus?.length) {
    return Promise.reject(new Error('Undefined skus'))
  }

  return Promise.all([
    magentoClient?.catalog.fetchProduct({ skus, base: true }),
    magentoClient?.catalog.fetchProduct({ skus, details: true }),
    magentoClient?.catalog.fetchProduct({ skus, links: true })
  ]).then((responses) => {
    const products: ProductData[] = []
    const productResponse = responses[0]?.data.data.products.items
    const detailsResponse = responses[1]?.data.data.products.items
    const linksResponse = responses[2]?.data.data.products.items

    responses[0]?.data.data?.products?.items.forEach((magentoProduct, i) => {
      const base = productResponse?.[i]
      const details = detailsResponse?.[i]
      const links = linksResponse?.[i]
      if (base && details && links) {
        const entity = {
          ...base,
          ...details,
          ...links
        }
        const product = entity.id ? normalizeProduct({
          product: entity,
          productAttributeList: productAttrList,
          storeConfig
        }) : undefined
        if (product) {
          products.push(product)
        }
      }
    })

    return products
  })
}
